var cream = '#fe9';
var black = '#320';
export default {
  googleFont: 'https://fonts.googleapis.com/css?family=Yellowtail|Roboto+Mono',
  fonts: {
    body: '"Yellowtail", cursive',
    monospace: '"Roboto Mono", Menlo, monospace'
  },
  colors: {
    text: black,
    background: cream,
    primary: black
  },
  styles: {
    root: {
      textAlign: 'center'
    },
    pre: {
      textAlign: 'left'
    }
  }
};